module.exports = __webpack_public_path__ + "img/next-arrow-gray.49913052.png";